var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6306 3.45887C15.2475 3.07562 14.7927 2.7716 14.2921 2.56418C13.7915 2.35676 13.2549 2.25 12.7131 2.25C12.1712 2.25 11.6347 2.35676 11.1341 2.56418C10.6335 2.7716 10.1786 3.07562 9.79558 3.45887L9.00058 4.25387L8.20558 3.45887C7.43181 2.6851 6.38235 2.2504 5.28808 2.2504C4.1938 2.2504 3.14435 2.6851 2.37058 3.45887C1.59681 4.23264 1.16211 5.28209 1.16211 6.37637C1.16211 7.47064 1.59681 8.5201 2.37058 9.29387L3.16558 10.0889L9.00058 15.9239L14.8356 10.0889L15.6306 9.29387C16.0138 8.9108 16.3178 8.45598 16.5253 7.95539C16.7327 7.45479 16.8394 6.91823 16.8394 6.37637C16.8394 5.8345 16.7327 5.29795 16.5253 4.79735C16.3178 4.29676 16.0138 3.84194 15.6306 3.45887V3.45887Z",
    stroke: "#828282",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartGray);
export default __webpack_public_path__ + "static/media/icon-heart-gray.d07c2b9bd5cb21696afeac0ed063be3f.svg";
export { ForwardRef as ReactComponent };